import { useContext, useEffect } from "react";
import { WorkspaceWindowIdContext, WorkspaceWindowTitleContext } from "./workspace-local-state";

/**
 * Name this window after whatever it is showing. The dock and switcher use it so a window that
 * has been put away can be told apart from another window of the same app and brought back by
 * name. Outside the windowed workspace there is nothing to name.
 */
export function useWorkspaceWindowTitle(title: string | null | undefined) {
  const id = useContext(WorkspaceWindowIdContext);
  const setTitle = useContext(WorkspaceWindowTitleContext);
  useEffect(() => {
    if (!id || !setTitle) return;
    setTitle(id, title?.trim() ? title.trim() : null);
  }, [id, setTitle, title]);
}
